import { Auth, Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    authenticationFlowType: 'CUSTOM_AUTH',
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_AWS_COGNITO_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_AWS_COGNITO_WEB_CLIENT_ID,

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,
  },
  // Storage: {
  //   bucket: process.env.REACT_APP_BUCKET,
  //   region: process.env.REACT_APP_REGION,
  //   ACL: 'public-read',
  //   identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  // },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: process.env.REACT_APP_API_URL,
        custom_header: async () => {
          const selectedOrganization = localStorage?.getItem('organization-context');
          return {
            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
            ...(selectedOrganization ? { 'x-selected-organization': selectedOrganization } : {}),
          };
        },
      },
      {
        name: 'business-api',
        endpoint: process.env.REACT_APP_API_URL,
      },
    ],
  },
});
